import styled from 'styled-components';
import { SecondaryFilters } from './SecondaryFilters';
import { PrimaryFilters } from './PrimaryFilters';

const Wrapper = styled.div`
  display: grid;
  grid-auto-columns: 1fr;
  grid-template-columns: 1fr min-content;
  grid-template-rows: 1fr;
  gap: 0px 0px;
  grid-template-areas: 'primaryFilters secondaryFilters';
`;

export const Filters = () => (
  <Wrapper>
    <PrimaryFilters />
    <SecondaryFilters />
  </Wrapper>
);
